<template>
  <AppLayout
    centered
    v-if="currentApplication && booking"
    parent="/applications"
    isDetails
    :title="booking.title"
    class="tabs-container"
  >
    <template v-slot:header>
      <div class="booking-details-header">
        <Chip :color="getApplicationStatusColor(currentApplication)">
          {{ getApplicationStatusTitle(currentApplication) | upperCase }}
        </Chip>
        <div class="entity-id">CA-{{ currentApplicationId }}</div>
      </div>
    </template>
    <template v-slot:body>
      <div class="container col-lg-10 col-sm-12">
        <ApplicationInvalid v-if="currentApplication.status === 'cancelled'" />
        <v-tabs
          centered
          v-model="selectedTab"
          class="basic-tabs"
          id="booking-tabs"
          @change="handleTabChange"
        >
          <v-tab v-for="section in sections" :key="section">
            {{ section | capitalize }}
          </v-tab>
        </v-tabs>
        <router-view
          v-if="currentApplication && booking"
          :currentBooking="booking"
          :currentApplication="currentApplication"
          isNestedInApplication
          isCandidate
        />
      </div>
    </template>
  </AppLayout>
  <v-overlay v-else z-index="10">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
</template>

<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import {
  GET_CURRENT_BOOKING,
  IS_LOADING_BOOKING
} from "@/store/modules/bookings/getters";
import {
  BOOKINGS_NAMESPACE,
  FETCH_CURRENT_BOOKING
} from "@/store/modules/bookings/actions";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import { FETCH_CURRENT_APPLICATION } from "@/store/modules/applications/actions";
import {
  GET_CURRENT_APPLICATION,
  GET_IS_FETCHING_CURRENT_APPLICATION
} from "@/store/modules/applications/getters";
import { createNamespacedHelpers } from "vuex";
import Chip from "@/components/common/Chip";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import {
  getApplicationStatusColor,
  getApplicationStatusTitle
} from "@/utils/applications";
import { includes } from "lodash";
import ApplicationInvalid from "@/views/applications/ApplicationInvalid";

const {
  mapActions: mapBookingActions,
  mapGetters: mapBookingGetters
} = createNamespacedHelpers(BOOKINGS_NAMESPACE);

const {
  mapActions: mapApplicationActions,
  mapGetters: mapApplicationGetters
} = createNamespacedHelpers(APPLICATION_NAMESPACE);

const { APPLICATIONS } = MAIN_NAVIGATION_ITEMS;
const TAB_INDEXES = {
  ROLE: 0,
  APPLICATION: 1
};

export default {
  name: "ApplicationTabs",
  components: {
    Chip,
    AppLayout,
    ApplicationInvalid
  },
  data() {
    return {
      selectedTab: 0
    };
  },
  computed: {
    ...mapBookingGetters({
      booking: GET_CURRENT_BOOKING,
      isLoadingBooking: IS_LOADING_BOOKING
    }),
    ...mapApplicationGetters({
      currentApplication: GET_CURRENT_APPLICATION,
      isLoadingApplication: GET_IS_FETCHING_CURRENT_APPLICATION
    }),
    currentApplicationId() {
      return this.$route.params.id;
    },
    initialSection() {
      const path = this.$router.currentRoute.path;
      switch (true) {
        case includes(path, "role"):
          return TAB_INDEXES.ROLE;
        case includes(path, "application"):
          return TAB_INDEXES.APPLICATION;
        default:
          return TAB_INDEXES.ROLE;
      }
    },
    sections() {
      return ["role", "application"];
    }
  },
  async created() {
    await this.fetchCurrentApplication(this.currentApplicationId);
    if (!this.currentApplication) {
      return this.$router.push("/pageNotFound");
    }
    await this.fetchCurrentBooking(this.currentApplication.booking.id);
    this.selectedTab = this.initialSection;
    document.title = `${this.currentApplication.booking.title} - Applications - Track`;
  },
  methods: {
    ...mapBookingActions({
      fetchCurrentBooking: FETCH_CURRENT_BOOKING
    }),
    ...mapApplicationActions({
      fetchCurrentApplication: FETCH_CURRENT_APPLICATION
    }),
    handleTabChange(selectedTab) {
      const tabName = this.sections[selectedTab];
      this.$router.replace(
        `/${APPLICATIONS}/${this.currentApplicationId}/${tabName}`
      );
    },
    getApplicationStatusTitle,
    getApplicationStatusColor
  }
};
</script>

<style lang="scss"></style>
